import React, { Component } from "react";
import './Music-List.css';
import Home from './Home';
import { Link } from 'react-router-dom';
import axios from '../tokenInterceptor';

class MusicList extends Component {
    constructor(props) {
        super(props);
        this.state={
            musicList: {
                "label_0_desc": {
                    "itemLabel": ""
                },
                "label_1_desc": {
                    "itemLabel": ""
                },
                "label_2_desc": {
                    "itemLabel": ""
                },
                "label_3_desc": {
                    "itemLabel": ""
                },
                "label_4_desc": {
                    "itemLabel": ""
                },
                "label_5_desc": {
                    "itemLabel": " "
                },
                "label_6_desc": {
                    "itemLabel": " "
                },
                "label_7_desc": {
                    "itemLabel": " "
                }
            },
            menu:"home",
            loader:true
        }
    }

    componentWillMount = () => {
        this.checkTokenExpire();
    }

    getMusicList = () => {
        let basicToken  = localStorage.getItem("auth-token");
        let config = {
            headers: {
                'Authorization': basicToken,
            }
        };
        console.log('Inside getMostPopularList');
        // axios.get("https://music-api.amazon.com/catalog/popular/", config).then((res) => {
        //     console.log("Status", res);
            // if (res.data.status == 200) {
            //     this.setState({ musicList: res.data.data.itemDescriptions, loader:false });
            // } else {
            //     this.setState({
            //         musicList: {
            //             "label_0_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_1_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_2_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_3_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_4_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_5_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_6_desc": {
            //                 "itemLabel": " "
            //             },
            //             "label_7_desc": {
            //                 "itemLabel": " "
            //             }
            //         }
            //     });
            // }
        // })
    }

    setSelectedMenu=(value)=>{
        this.setState({menu:value});
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            this.getMusicList();
        } else {
            // this.generateNewAccessToken();
        }
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getMusicList();
            } else {
                console.log("unable t generate token");
            }
        });
    }

    render() {
        return (
            <div className="left-section">
                <div className="main-wrapper">
                    <ul className="sidebar-nav">
                        <li className="list">
                            Amazon Music
                        </li>
                        <li className="list">
                            Popular
                        </li>
                        <li className="list">
                            Album
                        </li>
                        <li className="list">
                            Songs
                        </li>
                        <li className="list">
                            Genres
                        </li>
                        {/*<li className={`list ${this.state.menu === "amazon-music-unlimited" ? " " : ""}`} onClick={()=>this.setSelectedMenu("amazon-music-unlimited")}>*/}
                        {/*    <a href="/amazon-music-unlimited">{this.state.musicList.label_0_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === "playlists" ? " " : ""}`} onClick={()=>this.setSelectedMenu("playlists")}>*/}
                        {/*    <a href="/playlists">{this.state.musicList.label_1_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === "prime-station" ? " " : ""}`} onClick={()=>this.setSelectedMenu("prime-station")}>*/}
                        {/*    <a href="/prime-station">{this.state.musicList.label_2_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === " " ? " " : ""}`} onClick={()=>this.setSelectedMenu("chart")}>*/}
                        {/*    <a href="/chart">{this.state.musicList.label_3_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === " " ? " " : ""}`} onClick={()=>this.setSelectedMenu("recommended")}>*/}
                        {/*    <a href="/recommended">{this.state.musicList.label_4_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === " " ? " " : ""}`} onClick={()=>this.setSelectedMenu("new")}>*/}
                        {/*    <a href="/new">{this.state.musicList.label_5_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === " " ? " " : ""}`} onClick={()=>this.setSelectedMenu("sandbox")}>*/}
                        {/*    <a href="/sandbox">{this.state.musicList.label_6_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                        {/*<li className={`list ${this.state.menu === " " ? " " : ""}`} onClick={()=>this.setSelectedMenu("my-music")}>*/}
                        {/*    <a href="/my-music">{this.state.musicList.label_7_desc.itemLabel}</a>*/}
                        {/*</li>*/}
                    </ul>
                </div>
            </div>
        )
    }
}

export default MusicList;
